import { error } from "toastr";
import {
  API_FAIL,
  API_SUCCESS,
  GET_ALCOM_SCORE,
  GET_ALCOM_SCORE_FAIL,
  GET_ALCOM_SCORE_SUCCESS,
  GET_ALL_MISSING_ALERTS,
  GET_ALL_MISSING_ALERTS_FAIL,
  GET_ALL_MISSING_ALERTS_SUCCESS,
  GET_AWS_CHART_DATA,
  GET_AWS_CHART_DATA_FAIL,
  GET_AWS_CHART_DATA_SUCCESS,
  GET_AWS_REFRESH,
  GET_AWS_REFRESH_FAIL,
  GET_AWS_REFRESH_SUCCESS,
  GET_AWS_SCAN,
  GET_AWS_SCAN_FAIL,
  GET_AWS_SCAN_SUCCESS,
  GET_AWS_SCORES,
  GET_AWS_SCORES_FAIL,
  GET_AWS_SCORES_SUCCESS,
  GET_CHARTS_DATA,
  GET_CLOUD_DETAILS,
  GET_CLOUD_DETAILS_FAIL,
  GET_CLOUD_DETAILS_SUCCESS,
  GET_COMPLETED_ALERTS,
  GET_COMPLETED_ALERTS_FAIL,
  GET_COMPLETED_ALERTS_SUCCESS,
  GET_MASTER_NOTIFICATION_CHANNELS,
  GET_MASTER_NOTIFICATION_CHANNELS_FAIL,
  GET_MASTER_NOTIFICATION_CHANNELS_SUCCESS,
  GET_MASTER_RESOURCES,
  GET_MASTER_RESOURCES_FAIL,
  GET_MASTER_RESOURCES_SUCCESS,
  GET_MASTER_SYSTEMS,
  GET_MASTER_SYSTEMS_FAIL,
  GET_MASTER_SYSTEMS_SUCCESS,
  GET_MISSING_ALERTS,
  GET_MISSING_ALERTS_FAIL,
  GET_MISSING_ALERTS_SUCCESS,
  GET_MONITORING_SYSTEMS,
  GET_MONITORING_SYSTEMS_FAIL,
  GET_MONITORING_SYSTEMS_SUCCESS,
  GET_NEW_RELIC_COMPLETED_ALERTS,
  GET_NEW_RELIC_COMPLETED_ALERTS_FAIL,
  GET_NEW_RELIC_COMPLETED_ALERTS_SUCCESS,
  GET_NEW_RELIC_RESOURCES,
  GET_NEW_RELIC_RESOURCES_FAIL,
  GET_NEW_RELIC_RESOURCES_SUCCESS,
  GET_NEWRELIC_DEFAULT_THRESHOLD,
  GET_NEWRELIC_DEFAULT_THRESHOLD_FAIL,
  GET_NEWRELIC_DEFAULT_THRESHOLD_SUCCESS,
  GET_NEWRELIC_DYNAMIC_DEFAULT_THRESHOLD,
  GET_NEWRELIC_DYNAMIC_DEFAULT_THRESHOLD_FAIL,
  GET_NEWRELIC_DYNAMIC_DEFAULT_THRESHOLD_SUCCESS,
  GET_NEWRELIC_METRICS,
  GET_NEWRELIC_METRICS_FAIL,
  GET_NEWRELIC_METRICS_SUCCESS,
  GET_NEWRELIC_MISSING_ALERTS,
  GET_NEWRELIC_MISSING_ALERTS_FAIL,
  GET_NEWRELIC_MISSING_ALERTS_SUCCESS,
  GET_NEWRELIC_REFRESH,
  GET_NEWRELIC_REFRESH_FAIL,
  GET_NEWRELIC_REFRESH_SUCCESS,
  GET_NEWRELIC_SCAN,
  GET_NEWRELIC_SCAN_FAIL,
  GET_NEWRELIC_SCAN_SUCCESS,
  GET_NEWRELIC_SCORES,
  GET_NEWRELIC_SCORES_FAIL,
  GET_NEWRELIC_SCORES_SUCCESS,
  GET_NOTIFICATION_CHANNELS,
  GET_NOTIFICATION_CHANNELS_FAIL,
  GET_NOTIFICATION_CHANNELS_SUCCESS,
  GET_PROFILE,
  GET_PROFILE_FAIL,
  GET_PROFILE_SUCCESS,
  GET_SCORES,
  GET_SCORES_FAIL,
  GET_SCORES_SUCCESS,
  GET_TODO,
  GET_TODO_FAIL,
  GET_TODO_SUCCESS,
  GET_RECENTLY_ADDED_RESOURCES_AWS,
  GET_RECENTLY_ADDED_RESOURCES_AWS_SUCCESS,
  GET_RECENTLY_ADDED_RESOURCES_AWS_FAIL,
  GET_RECENTLY_ADDED_RESOURCES_AZURE,
  GET_RECENTLY_ADDED_RESOURCES_AZURE_FAIL,
  GET_RECENTLY_ADDED_RESOURCES_AZURE_SUCCESS,
  GET_RECENTLY_ADDED_RESOURCES_GCP,
  GET_RECENTLY_ADDED_RESOURCES_GCP_FAIL,
  GET_RECENTLY_ADDED_RESOURCES_GCP_SUCCESS,
  GET_RECENTLY_ADDED_RESOURCES_DATADOG,
  GET_RECENTLY_ADDED_RESOURCES_DATADOG_FAIL,
  GET_RECENTLY_ADDED_RESOURCES_DATADOG_SUCCESS,
  GET_RECENTLY_ADDED_RESOURCES_NEWRELIC,
  GET_RECENTLY_ADDED_RESOURCES_NEWRELIC_FAIL,
  GET_RECENTLY_ADDED_RESOURCES_NEWRELIC_SUCCESS,
  GET_RECENTLY_ADDED_RESOURCES_APPDYNAMICS,
  GET_RECENTLY_ADDED_RESOURCES_APPDYNAMICS_FAIL,
  GET_RECENTLY_ADDED_RESOURCES_APPDYNAMICS_SUCCESS,
  GET_ALCOM_SCORE_BY_SERVICE_IDS,
  GET_ALCOM_SCORE_BY_SERVICE_IDS_FAIL,
  GET_ALCOM_SCORE_BY_SERVICE_IDS_SUCCESS,
  GET_RECENTLY_ADDED_RESOURCES_SPLUNK,
  GET_RECENTLY_ADDED_RESOURCES_SPLUNK_FAIL,
  GET_RECENTLY_ADDED_RESOURCES_SPLUNK_SUCCESS,
  GET_RECENTLY_ADDED_RESOURCES_DYNATRACE,
  GET_RECENTLY_ADDED_RESOURCES_DYNATRACE_SUCCESS,
  GET_RECENTLY_ADDED_RESOURCES_DYNATRACE_FAIL,
  GET_RECENTLY_ADDED_RESOURCES_SYNTHETICS_FAIL,
  GET_RECENTLY_ADDED_RESOURCES_SYNTHETICS_SUCCESS,
  GET_RECENTLY_ADDED_RESOURCES_SYNTHETICS,
  GET_RECENTLY_ADDED_RESOURCES_OCI,
  GET_RECENTLY_ADDED_RESOURCES_OCI_FAIL,
  GET_RECENTLY_ADDED_RESOURCES_OCI_SUCCESS,
  GET_MASTER_LOGGING_SYSTEMS,
  GET_MASTER_LOGGING_SYSTEMS_FAIL,
  GET_MASTER_LOGGING_SYSTEMS_SUCCESS,
  GET_LOGGING_SYSTEMS,
  GET_LOGGING_SYSTEMS_FAIL,
  GET_LOGGING_SYSTEMS_SUCCESS,
  GET_RECENTLY_ADDED_RESOURCES_GRAFANA,
  GET_RECENTLY_ADDED_RESOURCES_GRAFANA_SUCCESS,
  GET_RECENTLY_ADDED_RESOURCES_GRAFANA_FAIL,
  GET_RECENTLY_ADDED_RESOURCES_SIGNOZ,
  GET_RECENTLY_ADDED_RESOURCES_SIGNOZ_SUCCESS, GET_RECENTLY_ADDED_RESOURCES_SIGNOZ_FAIL,
} from "./actionTypes";
import GrafanaResources from "../../pages/GrafanaResources";

export const apiSuccess = (actionType, data) => ({
  type: API_SUCCESS,
  payload: { actionType, data },
});

export const apiFail = (actionType, error) => ({
  type: API_FAIL,
  payload: { actionType, error },
});

// charts data
export const getChartsData = (periodType) => ({
  type: GET_CHARTS_DATA,
  payload: periodType
});

export const getTodo = () => ({
  type: GET_TODO,
})

export const getTodoSuccess = todo => ({
  type: GET_TODO_SUCCESS,
  payload: todo,
})

export const getTodoFail = error => ({
  type: GET_TODO_FAIL,
  payload: error,
})

export const getScrores = data => ({
  type: GET_SCORES,
  payload: data,
})

export const getScoresSuccess = scores => ({
  type: GET_SCORES_SUCCESS,
  payload: scores,
})

export const getScoresFail = error => ({
  type: GET_SCORES_FAIL,
  payload: error,
})

export const getProfile = () => ({
  type: GET_PROFILE,
})

export const getProfileSuccess = todo => ({
  type: GET_PROFILE_SUCCESS,
  payload: todo,
})

export const getProfileFail = error => ({
  type: GET_PROFILE_FAIL,
  payload: error,
})

export const getMasterResources = () => ({
  type: GET_MASTER_RESOURCES,
})

export const getMasterResourcesSuccess = masterResources => ({
  type: GET_MASTER_RESOURCES_SUCCESS,
  payload: masterResources,
})

export const getMasterResourcesFail = error => ({
  type: GET_MASTER_RESOURCES_FAIL,
  payload: error,
})

export const getMasterNotificationChannels = () => ({
  type: GET_MASTER_NOTIFICATION_CHANNELS,
})

export const getMasterNotificationChannelsSuccess = notification_channel => ({
  type: GET_MASTER_NOTIFICATION_CHANNELS_SUCCESS,
  payload: notification_channel,
})

export const getMasterNotificationChannelsFail = error => ({
  type: GET_MASTER_NOTIFICATION_CHANNELS_FAIL,
  payload: error,
})

export const getAwsRefresh = () => ({
  type: GET_AWS_REFRESH,
})

export const getAwsRefreshSuccess = aws_refresh => ({
  type: GET_AWS_REFRESH_SUCCESS,
  payload: aws_refresh,
})

export const getAwsRefreshFail = error => ({
  type: GET_AWS_REFRESH_FAIL,
  payload: error,
})

export const getMissingAlerts = (data) => ({
  type: GET_MISSING_ALERTS,
  payload: data,
})

export const getMissingAlertsSuccess = missing_alerts => ({
  type: GET_MISSING_ALERTS_SUCCESS,
  payload: missing_alerts,
})

export const getMissingAlertsFail = error => ({
  type: GET_MISSING_ALERTS_FAIL,
  payload: error,
})

export const getMasterSystems = () => ({
  type: GET_MASTER_SYSTEMS,
})

export const getMasterSystemsSuccess = master_systems => ({
  type: GET_MASTER_SYSTEMS_SUCCESS,
  payload: master_systems,
})

export const getMasterSystemsFail = error => ({
  type: GET_MASTER_SYSTEMS_FAIL,
  payload: error,
})

export const getCloudDetails = () => ({
  type: GET_CLOUD_DETAILS,
})

export const getCloudDetailsSuccess = cloud_details => ({
  type: GET_CLOUD_DETAILS_SUCCESS,
  payload: cloud_details,
})

export const getCloudDetailsFail = error => ({
  type: GET_CLOUD_DETAILS_FAIL,
  payload: error,
})

export const getNotificationChannels = () => ({
  type: GET_NOTIFICATION_CHANNELS,
})

export const getNotificationChannelsSuccess = notification_channels => ({
  type: GET_NOTIFICATION_CHANNELS_SUCCESS,
  payload: notification_channels,
})

export const getNotificationChannelsFail = error => ({
  type: GET_NOTIFICATION_CHANNELS_FAIL,
  payload: error,
})

export const getCompletedAlerts = (data) => ({
  type: GET_COMPLETED_ALERTS,
  payload: data,
})

export const getCompletedAlertsSuccess = completed_alerts => ({
  type: GET_COMPLETED_ALERTS_SUCCESS,
  payload: completed_alerts,
})

export const getCompletedAlertsFail = error => ({
  type: GET_COMPLETED_ALERTS_FAIL,
  payload: error,
})

export const getNewRelicResources = () => ({
  type: GET_NEW_RELIC_RESOURCES,
})

export const getNewRelicResourcesSuccess = new_relic_resources => ({
  type: GET_NEW_RELIC_RESOURCES_SUCCESS,
  payload: new_relic_resources,
})

export const getNewRelicResourcesFail = error => ({
  type: GET_NEW_RELIC_RESOURCES_FAIL,
  payload: error,
})

export const getMonitoringSystems = () => ({
  type: GET_MONITORING_SYSTEMS,
})

export const getMonitoringSystemsSuccess = monitoring_systems => ({
  type: GET_MONITORING_SYSTEMS_SUCCESS,
  payload: monitoring_systems,
})

export const getMonitoringSystemsFail = error => ({
  type: GET_MONITORING_SYSTEMS_FAIL,
  payload: error,
})

export const getNewRelicMetrics = (data) => ({
  type: GET_NEWRELIC_METRICS,
  payload: data,
})

export const getNewRelicMetricsSuccess = new_relic_metrics => ({
  type: GET_NEWRELIC_METRICS_SUCCESS,
  payload: new_relic_metrics,
})

export const getNewRelicMetricsFail = error => ({
  type: GET_NEWRELIC_METRICS_FAIL,
  payload: error,
})

export const getNewRelicMissingAlerts = (data) => ({
  type: GET_NEWRELIC_MISSING_ALERTS,
  payload: data,
})

export const getNewRelicMissingAlertsSuccess = new_relic_missing_alerts => ({
  type: GET_NEWRELIC_MISSING_ALERTS_SUCCESS,
  payload: new_relic_missing_alerts,
})

export const getNewRelicMissingAlertsFail = error => ({
  type: GET_NEWRELIC_MISSING_ALERTS_FAIL,
  payload: error,
})

export const getNewRelicDefaultThreshold = (data) => ({
  type: GET_NEWRELIC_DEFAULT_THRESHOLD,
  payload: data,
})

export const getNewRelicDefaultThresholdSuccess = new_relic_default_threshold => ({
  type: GET_NEWRELIC_DEFAULT_THRESHOLD_SUCCESS,
  payload: new_relic_default_threshold,
})

export const getNewRelicDefaultThresholdFail = error => ({
  type: GET_NEWRELIC_DEFAULT_THRESHOLD_FAIL,
  payload: error,
})

export const getNewRelicDynamicDefaultThreshold = (data) => ({
  type: GET_NEWRELIC_DYNAMIC_DEFAULT_THRESHOLD,
  payload: data,
})

export const getNewRelicDynamicDefaultThresholdSuccess = new_relic_dynamic_default_threshold => ({
  type: GET_NEWRELIC_DYNAMIC_DEFAULT_THRESHOLD_SUCCESS,
  payload: new_relic_dynamic_default_threshold,
})

export const getNewRelicDynamicDefaultThresholdFail = error => ({
  type: GET_NEWRELIC_DYNAMIC_DEFAULT_THRESHOLD_FAIL,
  payload: error,
})

export const getNewRelicCompletedAlerts = (data) => ({
  type: GET_NEW_RELIC_COMPLETED_ALERTS,
  payload: data,
})

export const getNewRelicCompletedAlertsSuccess = new_relic_completed_alerts => ({
  type: GET_NEW_RELIC_COMPLETED_ALERTS_SUCCESS,
  payload: new_relic_completed_alerts,
})

export const getNewRelicCompletedAlertsFail = error => ({
  type: GET_NEW_RELIC_COMPLETED_ALERTS_FAIL,
  payload: error,
})

export const getAwsScan = (data) => ({
  type: GET_AWS_SCAN,
  payload: data,
})

export const getAwsScanSuccess = aws_scan => ({
  type: GET_AWS_SCAN_SUCCESS,
  payload: aws_scan,
})

export const getAwsScanFail = error => ({
  type: GET_AWS_SCAN_FAIL,
  payload: error,
})

export const getNewRelicScan = (data) => ({
  type: GET_NEWRELIC_SCAN,
  payload: data,
})

export const getNewRelicScanSuccess = newrelic_scan => ({
  type: GET_NEWRELIC_SCAN_SUCCESS,
  payload: newrelic_scan,
})

export const getNewRelicScanFail = error => ({
  type: GET_NEWRELIC_SCAN_FAIL,
  payload: error,
})

export const getNewRelicRefresh = () => ({
  type: GET_NEWRELIC_REFRESH,
})

export const getNewRelicRefreshSuccess = newrelic_refresh => ({
  type: GET_NEWRELIC_REFRESH_SUCCESS,
  payload: newrelic_refresh,
})

export const getNewRelicRefreshFail = error => ({
  type: GET_NEWRELIC_REFRESH_FAIL,
  payload: error,
})

export const getAwsScores = (data) => ({
  type: GET_AWS_SCORES,
  payload: data,
})

export const getAwsScoresSuccess = aws_scores => ({
  type: GET_AWS_SCORES_SUCCESS,
  payload: aws_scores,
})

export const getAwsScoresFail = error => ({
  type: GET_AWS_SCORES_FAIL,
  payload: error,
})

export const getAllMissingAlerts = () => ({
  type: GET_ALL_MISSING_ALERTS
})

export const getAllMissingAlertsSuccess = aws_scores => ({
  type: GET_ALL_MISSING_ALERTS_SUCCESS,
  payload: aws_scores,
})

export const getAllMissingAlertsFail = error => ({
  type: GET_ALL_MISSING_ALERTS_FAIL,
  payload: error,
})

export const getAlcomScore = () => ({
  type: GET_ALCOM_SCORE
})

export const getAlcomScoreSuccess = alcom_score => ({
  type: GET_ALCOM_SCORE_SUCCESS,
  payload: alcom_score,
})

export const getAlcomScoreFail = error => ({
  type: GET_ALCOM_SCORE_FAIL,
  payload: error,
})

export const getAWSChartData = () => ({
  type: GET_AWS_CHART_DATA
})

export const getAWSChartDataSuccess = chart_data => ({
  type: GET_AWS_CHART_DATA_SUCCESS,
  payload: chart_data,
})

export const getAWSChartDataFail = error => ({
  type: GET_AWS_CHART_DATA_FAIL,
  payload: error,
})

export const getNewRelicScores = (data) => ({
  type: GET_NEWRELIC_SCORES,
  payload: data,
})

export const getNewRelicScoresSuccess = newrelic_scores => ({
  type: GET_NEWRELIC_SCORES_SUCCESS,
  payload: newrelic_scores,
})

export const getNewRelicScoresFail = error => ({
  type: GET_NEWRELIC_SCORES_FAIL,
  payload: error,
})

export const getRecentlyAddedResourcesAWS = data  =>
  
 { return {
  type: GET_RECENTLY_ADDED_RESOURCES_AWS,
  payload: data,
}}

export const getRecentlyAddedResourcesAWSSuccess = data => 
  {return {
  type: GET_RECENTLY_ADDED_RESOURCES_AWS_SUCCESS,
  payload: data,
  }}

export const getRecentlyAddedResourcesAWSFail = error => ({
  type: GET_RECENTLY_ADDED_RESOURCES_AWS_FAIL,
  payload: error,
})

export const getRecentlyAddedResourcesAzure = data => ({
  type: GET_RECENTLY_ADDED_RESOURCES_AZURE,
  payload: data,
})

export const getRecentlyAddedResourcesAzureSuccess = AzureData => ({
  type: GET_RECENTLY_ADDED_RESOURCES_AZURE_SUCCESS,
  payload: AzureData,
})

export const getRecentlyAddedResourcesAzureFail = error => ({
  type: GET_RECENTLY_ADDED_RESOURCES_AZURE_FAIL,
  payload: error,
})

export const getRecentlyAddedResourcesGCP = data => ({
  type: GET_RECENTLY_ADDED_RESOURCES_GCP,
  payload: data,
})

export const getRecentlyAddedResourcesGCPSuccess = GCPData => ({
  type: GET_RECENTLY_ADDED_RESOURCES_GCP_SUCCESS,
  payload: GCPData,
})

export const getRecentlyAddedResourcesGCPFail = error => ({
  type: GET_RECENTLY_ADDED_RESOURCES_GCP_FAIL,
  payload: error,
})

export const getRecentlyAddedResourcesDatadog = data => ({
  type: GET_RECENTLY_ADDED_RESOURCES_DATADOG,
  payload: data,
})

export const getRecentlyAddedResourcesDatadogSuccess = DatadogData => ({
  type: GET_RECENTLY_ADDED_RESOURCES_DATADOG_SUCCESS,
  payload: DatadogData,
})

export const getRecentlyAddedResourcesDatadogFail = error => ({
  type: GET_RECENTLY_ADDED_RESOURCES_DATADOG_FAIL,
  payload: error,
})

export const getRecentlyAddedResourcesNewRelic = data => ({
  type: GET_RECENTLY_ADDED_RESOURCES_NEWRELIC,
  payload: data,
})

export const getRecentlyAddedResourcesNewRelicSuccess = NewRelicData => ({
  type: GET_RECENTLY_ADDED_RESOURCES_NEWRELIC_SUCCESS,
  payload: NewRelicData,
})

export const getRecentlyAddedResourcesNewRelicFail = error => ({
  type: GET_RECENTLY_ADDED_RESOURCES_NEWRELIC_FAIL,
  payload: error,
})

export const getRecentlyAddedResourcesAppDynamics = data => ({
  type: GET_RECENTLY_ADDED_RESOURCES_APPDYNAMICS,
  payload: data,
})

export const getRecentlyAddedResourcesAppDynamicsSuccess = AppDynamicsResources => ({
  type: GET_RECENTLY_ADDED_RESOURCES_APPDYNAMICS_SUCCESS,
  payload: AppDynamicsResources,
})

export const getRecentlyAddedResourcesAppDynamicsFail = error => ({
  type: GET_RECENTLY_ADDED_RESOURCES_APPDYNAMICS_FAIL,
  payload: error
})

export const getRecentlyAddedResourcesGrafana = data => ({
  type: GET_RECENTLY_ADDED_RESOURCES_GRAFANA,
  payload: data,
})

export const getRecentlyAddedResourcesGrafanaSuccess = GrafanaResources => ({
  type: GET_RECENTLY_ADDED_RESOURCES_GRAFANA_SUCCESS,
  payload: GrafanaResources,
})

export const getRecentlyAddedResourcesGrafanaFail = error => ({
  type: GET_RECENTLY_ADDED_RESOURCES_GRAFANA_FAIL,
  payload: error
})

export const getRecentlyAddedResourcesSignoz = data => ({
  type: GET_RECENTLY_ADDED_RESOURCES_SIGNOZ,
  payload: data,
})

export const getRecentlyAddedResourcesSignozSuccess = GrafanaResources => ({
  type: GET_RECENTLY_ADDED_RESOURCES_SIGNOZ_SUCCESS,
  payload: GrafanaResources,
})

export const getRecentlyAddedResourcesSignozFail = error => ({
  type: GET_RECENTLY_ADDED_RESOURCES_SIGNOZ_FAIL,
  payload: error
})

export const getRecentlyAddedResourcesSplunk = data => ({
  type: GET_RECENTLY_ADDED_RESOURCES_SPLUNK,
  payload: data,
})

export const getRecentlyAddedResourcesSplunkFail = error => ({
  type: GET_RECENTLY_ADDED_RESOURCES_SPLUNK_FAIL,
  payload: error,
})

export const getRecentlyAddedResourcesSplunkSuccess = SplunkData => ({
  type: GET_RECENTLY_ADDED_RESOURCES_SPLUNK_SUCCESS,
  payload: SplunkData,
})

export const getAlcomScoreByServiceIds = service_ids => ({
  type: GET_ALCOM_SCORE_BY_SERVICE_IDS,
  payload: service_ids,
})

export const getAlcomScoreByServiceIdsSuccess = AlcomScores => ({
  type: GET_ALCOM_SCORE_BY_SERVICE_IDS_SUCCESS,
  payload: AlcomScores
})

export const getAlcomScoreByServiceIdsFail = error => ({
  type: GET_ALCOM_SCORE_BY_SERVICE_IDS_FAIL,
  payload: error
})


export const getRecentlyAddedResourcesDynatrace = data => ({
    type: GET_RECENTLY_ADDED_RESOURCES_DYNATRACE,
    payload: data,
})

export const getRecentlyAddedResourcesDynatraceSuccess = DynatraceData => ({
    type: GET_RECENTLY_ADDED_RESOURCES_DYNATRACE_SUCCESS,
    payload: DynatraceData,
})

export const getRecentlyAddedResourcesDynatraceFail = error => ({
    type: GET_RECENTLY_ADDED_RESOURCES_DYNATRACE_FAIL,
    payload: error,
})

export const getRecentlyAddedResourcesOci = data => ({
    type: GET_RECENTLY_ADDED_RESOURCES_OCI,
    payload: data
})

export const getRecentlyAddedResourcesOciSuccess = OciData => ({
    type: GET_RECENTLY_ADDED_RESOURCES_OCI_SUCCESS,
    payload: OciData,
})

export const getRecentlyAddedResourcesOciFail = error => ({
    type: GET_RECENTLY_ADDED_RESOURCES_OCI_FAIL,
    payload: error,
})

export const getRecentlyAddedResourcesSynthetics = data => ({
  type: GET_RECENTLY_ADDED_RESOURCES_SYNTHETICS,
  payload: data
})

export const getRecentlyAddedResourcesSyntheticsSuccess = SyntheticsData => ({
  type: GET_RECENTLY_ADDED_RESOURCES_SYNTHETICS_SUCCESS,
  payload: SyntheticsData,
})

export const getRecentlyAddedResourcesSyntheticsFail = error => ({
  type: GET_RECENTLY_ADDED_RESOURCES_SYNTHETICS_FAIL,
  payload: error,
})

export const getMasterLoggingSystems = () => ({
  type: GET_MASTER_LOGGING_SYSTEMS,
})

export const getMasterLoggingSystemsSuccess = master_systems => ({
  type: GET_MASTER_LOGGING_SYSTEMS_SUCCESS,
  payload: master_systems,
})

export const getMasterLoggingSystemsFail = error => ({
  type: GET_MASTER_LOGGING_SYSTEMS_FAIL,
  payload: error,
})

export const getLoggingSystems = () => ({
  type: GET_LOGGING_SYSTEMS,
})

export const getLoggingSystemsSuccess = logging_systems => ({
  type: GET_LOGGING_SYSTEMS_SUCCESS,
  payload: logging_systems,
})

export const getLoggingSystemsFail = error => ({
  type: GET_LOGGING_SYSTEMS_FAIL,
  payload: error,
})

